export default {
  getcode: '/sso/getSms',
  changepwd: '/sso/resetPwd',
};



// WEBPACK FOOTER //
// ./src/api/password.js